<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title v-if="!typeProp" class="mt-4 me-4">
        {{ $t($route.name) }}</v-toolbar-title
      >
      <div v-if="!isMobile && !isTablet" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="
          selected.length > 0 &&
          !isMobile &&
          type !== 'removedInvoices' &&
          $store.state.permissions &&
          $store.state.permissions.includes(
            'remove' + type[0].toUpperCase() + type.substring(1)
          )
        "
        outlined
        @click="openDeleteDialog(null, 'delete')"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="
              $store.state.permissions &&
              $store.state.permissions.includes('importExcelInvoice')
            "
            link
            @click="openUploadDialog"
          >
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0 && lockPermission"
            link
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0"
            link
            @click="unlockGroup('unlock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-open-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('unlock')" />
          </v-list-item>
          <v-list-item
            v-if="type !== 'removedInvoices'"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            link
            @click="groupPrintDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-settings</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('groupPrint')" />
          </v-list-item>
          <v-list-item
            v-show="
              type === 'sell' &&
              $store.state.permissions &&
              $store.state.permissions.includes('reviewDigikalaOrder') &&
              digikalaPermission
            "
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            link
            @click="reviewDigikalaOrder"
          >
            <v-list-item-icon>
              <v-icon>mdi-shopping-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('reviewDigikalaOrder')" />
          </v-list-item>
          <v-list-item
            v-show="type === 'removedInvoices'"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            link
            @click="refreshRemovedItem"
          >
            <v-list-item-icon>
              <v-icon>mdi-delete-restore</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refreshRemovedItem')" />
          </v-list-item>
          <v-list-item
            v-show="$route.name === 'sellTaxPayer' && taxPayerSystem"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            link
            @click="sendTaxInvoice('review')"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-document-refresh-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('reviewInvoices')" />
          </v-list-item>
          <v-list-item link @click="barcode">
            <v-list-item-icon>
              <v-icon>mdi-barcode</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('productBarcode')" />
          </v-list-item>
          <!-- <v-list-item
            v-show="(type === 'sell' || type === 'returnSell') && $store.state.permissions && $store.state.permissions.includes('sendTaxPayer') && $store.state.allConfig && $store.state.allConfig.taxPayerSystem && $store.state.allConfig.taxPayerSystem == 'active'"
            :disabled="(!selected || selected && selected.length === 0 ? true : false)"
            link
            @click="sendTaxInvoice"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-document-arrow-right-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('sendTaxInvoice')" />
          </v-list-item> -->
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          <!-- <v-list-item
            link
            @click="taxPayerConfirmationVMenu(item)"
          >
            <v-list-item-icon>
              <v-icon>mdi-send</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('taxPayerSystem')" />
          </v-list-item> -->
          <v-list-item v-if="isMobile || isTablet" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="(isMobile || isTablet) && type !== 'removedInvoices'"
            link
            @getAllRows="getAllRows"
          >
            <export-excel
              ref="refExcel"
              :data="excelItems"
              worksheet="abriron.com"
              name="data.xls"
              type="xls"
              class="float-left d-flex"
              :title="$store.state.abrName"
              :total-prop="pageCount"
              :page-prop="excelPage"
              @getAllRows="getAllRows"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('excel')" />
            </export-excel>
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @click="printDialog = true">
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="
              (isMobile || isTablet) &&
              $route.name !== 'sellTaxPayer' &&
              $store.state.permissions &&
              $store.state.permissions.includes(type)
            "
            link
            @click="goTo(type)"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet && type !== 'removedInvoices'"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="
          !isMobile &&
          !isTablet &&
          $route.name !== 'sellTaxPayer' &&
          $store.state.permissions &&
          $store.state.permissions.includes(type)
        "
        outlined
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col
        class="px-2"
        :class="{ 'mb-4': !isMobile && !isTablet, 'mb-2': isMobile || isTablet }"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col v-show="!isMobile" class="pa-0" cols="12" md="12">
        <div class="d-flex align-center justify-space-between gap-2">
          <v-chip-group mandatory active-class="primary--text">
            <v-chip label outlined>
              {{ $t("sumNetAmount") }} :
              {{ $numberFormat(summary ? summary.amount : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
            <v-chip label outlined>
              {{ $t("sumDiscount") }} :
              {{ $numberFormat(summary ? summary.discount : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
            <v-chip v-if="hasCustomerClub" label outlined>
              {{ $t("club-credit") }} :
              {{ $numberFormat(summary ? summary.credit : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
            <v-chip label outlined>
              {{ $t("sumTax") }} : {{ $numberFormat(summary ? summary.tax : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
            <v-chip label outlined>
              {{ $t("sumClearAmount") }} :
              {{ $numberFormat(summary ? summary.net_amount : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
          </v-chip-group>
          <div class="d-flex align-center gap-2">
            <!--tax payer-->
            <v-btn
              v-if="taxPayerSystem && (type == 'sell' || type == 'returnSell')"
              color="secondary"
              outlined
              height="32"
              :loading="loading"
              @click="taxPayerConfirmation"
            >
              <span>
                {{
                  taxPayerSelectedItems && taxPayerSelectedItems.length != 0
                    ? "(" + taxPayerSelectedItems.length + ")"
                    : ""
                }}
                {{ $t("taxPayerSystem") }}
              </span>
            </v-btn>
            <!--Average-->
            <v-btn
              color="secondary"
              outlined
              height="32"
              class="ml-2"
              :loading="loading"
              @click="fetchCheckAverageFirst"
            >
              <span class="ml-2">
                {{ selectedCheck.length != 0 ? "(" + selectedCheck.length + ")" : "" }}
                {{ $t("invoice-count") }}
              </span>
              <my-icon
                :name="'check-average'"
                :width="18"
                :height="19"
                :cursor-pointer="true"
              />
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-col cols="12" class="px-2">
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :page.sync="page"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-if="isMobile" v-slot:item="{ item, index }">
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-green':
                    item.type == 'sell' || item.type == 'presale' ? true : false,
                  'mobile-td-list-border-red': item.type == 'purchase' ? true : false,
                  'mobile-td-list-border-primary':
                    item.type == 'returnSell' || item.type == 'returnPurchase'
                      ? true
                      : false,
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          link
                          :disabled="item.lock ? true : false"
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item link @click="print(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('print')" />
                        </v-list-item>
                        <v-list-item link @click="fishPrint(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-paper-roll-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceRollprint')" />
                        </v-list-item>
                        <v-list-item v-if="type == 'sell'" link @click="invoiceSms(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-message-text-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('sendInvoiceSMS')" />
                        </v-list-item>
                        <v-list-item
                          v-if="item.entrepot"
                          link
                          @click="entrepotPrint(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-warehouse</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
                        </v-list-item>
                        <v-list-item link @click="copyInvoice(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-content-copy</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceCopy')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/' + type + '/edit/' + item.uid"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item
                          v-show="
                            removePermission(type) && resolveDeleteBtnVisibility(item)
                          "
                          link
                          :disabled="item.lock ? true : false"
                          @click="openDeleteDialog(item, 'delete')"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.customer ? item.customer.name : "" }} ({{ item.number }})
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("document-number") }} :
                    {{ item.doc_header ? item.doc_header.number : "" }} | {{ $t("id") }} :
                    {{ item.id }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("discount") }} :
                    {{ $numberFormat(item.discount ? item.discount : 0) }} |
                    {{ $t("tax") }} : {{ $numberFormat(item.tax ? item.tax : 0) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("date") }} : {{ item.date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-for="(integrate, index) in item.integrator"
                        :key="index"
                        color="green"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ $t("registerBy") }} : {{ $t(integrate.key) }} |
                          {{ $t("id") }} : {{ integrate.value }}
                          {{
                            integrate.number
                              ? " | " + $t("number") + ":" + integrate.number
                              : ""
                          }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-if="item.payed"
                        class="ms-1"
                        :color="
                          parseFloat(item.price.price) - parseFloat(item.payed.amount) > 0
                            ? 'red'
                            : 'green'
                        "
                        small
                        outlined
                        style="cursor: pointer"
                        @click.stop="openPayedDetailsDialog(item)"
                      >
                        {{
                          parseFloat(item.price.price) - parseFloat(item.payed.amount) > 0
                            ? $t("remainPrice") +
                              " " +
                              $numberFormat(
                                parseFloat(item.price.price) -
                                  parseFloat(item.payed.amount)
                              )
                            : $t("payed")
                        }}
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="edit(item)">
                    {{ $numberFormat(item.price ? item.price.NetPrice : 0) }}
                    {{ item.currency ? item.currency.symbol : "" }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.action="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item link :disabled="item.lock ? true : false" @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="lockPermission"
                link
                @click="lock(item, item.lock ? 'unlock' : 'lock')"
              >
                <v-list-item-icon>
                  <v-icon :color="item.lock ? 'green' : 'pink'">
                    {{ item.lock ? "mdi-lock-open-outline" : "mdi-lock-outline" }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.lock ? $t('unlock') : $t('lock')" />
              </v-list-item>
              <v-list-item
                v-show="type == 'sell' || type == 'presale'"
                link
                @click="editCategory(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('editCasher')" />
              </v-list-item>
              <v-list-item link @click="print(item)">
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item link @click="selectedPrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-format-list-group</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print') + '(' + $t('new') + ')'" />
              </v-list-item>
              <v-list-item link @click="fishPrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-paper-roll-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceRollprint')" />
              </v-list-item>
              <v-list-item
                v-if="
                  !documentPermmission && item.attachments && item.attachments.length > 0
                "
                link
                @click="openDocumentsDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-attachment</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('documents')" />
              </v-list-item>
              <v-list-item
                v-if="type == 'sell' || type == 'presale'"
                link
                @click="invoiceSms(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-message-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('sendInvoiceSMS')" />
              </v-list-item>
              <v-list-item v-if="item.entrepot" link @click="entrepotPrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-warehouse</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
              </v-list-item>
              <v-list-item link @click="barcodeSingle(item)">
                <v-list-item-icon>
                  <v-icon>mdi-barcode</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('barcode')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-if="taxPayerSystem && (type == 'sell' || type == 'returnSell')"
                link
                @click="taxPayerConfirmationVMenu(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-send</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('taxPayerSystem')" />
              </v-list-item>
              <v-list-item link @click="copyInvoice(item)">
                <v-list-item-icon>
                  <v-icon>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceCopy')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + type + '/edit/' + item.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item
                v-show="
                  item.tax_payer &&
                  item.tax_payer.taxid &&
                  item.tax_payer.status == 'done'
                "
                link
                :disabled="item.lock ? true : false"
                @click="editTaxInvoice(item)"
              >
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-note-edit-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('sendEditTaxInvoice')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission(type) && resolveAnnulmentBtnVisibility(item)"
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item, 'annulment')"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-close-circle-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('annulmentInvoice')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission(type) && resolveDeleteBtnVisibility(item)"
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item, 'delete')"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.row="{ item }">
          {{ parseInt(items.indexOf(item)) + parseInt(from) }}
        </template>
        <template v-slot:item.id="{ item }">
          <div>
            <a @click="edit(item)">
              {{ item.number != null ? item.number : $t("haveNot") }}
              {{ item.official_number ? "(" + item.official_number + ")" : "" }}
            </a>
            <v-chip
              v-if="type === 'removedInvoices'"
              :color="
                item.type === 'purchase' || item.type === 'returnPurchase'
                  ? 'blue'
                  : 'green'
              "
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ $t(item.type) }}
              </span>
            </v-chip>
          </div>
          <div>
            <v-card-text class="pa-0 text-caption text-disable secondary--text">
              #{{ item.id != null ? item.id : $t("haveNot") }}
            </v-card-text>
            <v-icon v-if="item.lock" color="red" style="font-size: 22px">
              mdi-lock-outline
            </v-icon>
          </div>
        </template>
        <template v-slot:item.doc_header.number="{ item }">
          <a
            v-if="item.doc_header"
            @click="openComponent('accountingPrint', item.doc_head_id)"
            class="text-disable secondary--text"
          >
            {{ item.doc_header.number }}
          </a>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
            {{ $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.customer.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-1"
              @click="openComponent('account', item.customer_id)"
            >
              {{ item.customer ? item.customer.name : $t("haveNot") }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.customer"
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.customer.fin_id)"
                >
                  <v-icon color="teal" style="font-size: 22px">
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("turnover") }}</span>
            </v-tooltip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{
              item.customer && item.customer.mobile != null && item.customer.mobile != ""
                ? item.customer.mobile
                : $t("haveNot")
            }}
          </v-card-text>
        </template>
        <template v-slot:item.date="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.date ? item.date : $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{
            $numberFormat(
              item.price ? item.price.price : 0,
              item.currency ? item.currency.decimal : 0
            )
          }}
          {{ item.currency ? item.currency.symbol : "" }}
          <div class="d-flex align-center gap-1" v-if="item.discount != 0">
            <v-card-text class="pa-0 text-caption text-disable secondary--text"
              >{{ $t("discount") }}:</v-card-text
            >
            <v-card-text class="pa-0 text-caption">{{
              $numberFormat(item.discount ? item.discount : 0)
            }}</v-card-text>
          </div>
          <div class="d-flex align-center gap-1" v-if="item.tax != 0">
            <v-card-text class="pa-0 text-caption text-disable secondary--text"
              >{{ $t("tax") }}:</v-card-text
            >
            <v-card-text class="pa-0 text-caption">{{
              $numberFormat(item.tax ? item.tax : 0)
            }}</v-card-text>
          </div>
        </template>
        <template v-slot:item.payed.amount="{ item }">
          <v-card-text
            class="pa-0 text-body-2"
            v-if="item.payed != null && item.payed.amount != 0"
          >
            {{
              $numberFormat(
                item.payed ? item.payed.amount : 0,
                item.currency ? item.currency.decimal : 0
              )
            }}
            {{ item.currency ? item.currency.symbol : "" }}
          </v-card-text>
          <div
            class="d-flex align-center gap-1"
            v-if="item.payed != null && item.payed.paymentsAmount != 0"
          >
            <v-card-text class="pa-0 text-caption text-disable secondary--text">{{
              $t("cash")
            }}</v-card-text>
            <v-card-text class="pa-0 text-caption">
              {{
                $numberFormat(
                  item.payed ? item.payed.paymentsAmount : 0,
                  item.currency ? item.currency.decimal : 0
                )
              }}
              {{ item.currency ? item.currency.symbol : "" }}
            </v-card-text>
          </div>
          <div
            class="d-flex align-center gap-1"
            v-if="item.payed != null && item.payed.checksAmount != 0"
          >
            <v-card-text class="pa-0 text-caption text-disable secondary--text"
              >{{ $t("check") }}:</v-card-text
            >
            <v-card-text class="pa-0 text-caption">
              {{
                $numberFormat(
                  item.payed ? item.payed.checksAmount : 0,
                  item.currency ? item.currency.decimal : 0
                )
              }}
              {{ item.currency ? item.currency.symbol : "" }}
            </v-card-text>
          </div>
          <div
            v-if="hasCustomerClub && item.creditStatus && item.credit != 0"
            class="d-flex align-center gap-1"
          >
            <v-card-text class="pa-0 text-caption text-disable secondary--text"
              >{{ $t("club-credit") }}:</v-card-text
            >
            <v-card-text class="pa-0 text-caption">
              {{ $numberFormat(item.credit) }}
              {{ item.currency ? item.currency.symbol : "" }}
            </v-card-text>
          </div>
          <v-chip
            v-if="item.payed != null"
            class="mx-0"
            :color="
              parseFloat(item.price.price) -
                parseFloat(item.payed.amount) -
                parseFloat(item.credit) >
              0
                ? 'red'
                : 'green'
            "
            small
            outlined
            style="cursor: pointer"
            @click.stop="openPayedDetailsDialog(item)"
          >
            {{
              parseFloat(item.price.price) -
                parseFloat(item.payed.amount) -
                parseFloat(item.credit) >
              0
                ? $t("remainPrice") +
                  " " +
                  $numberFormat(
                    parseFloat(item.price.price) -
                      parseFloat(item.payed.amount) -
                      parseFloat(item.credit)
                  )
                : $t("payed")
            }}
          </v-chip>
          <v-card-text
            v-if="item.payed == null"
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.pre_invoice="{ item }">
          <v-icon v-if="item.pre_invoice == 'active'" color="green"> mdi-check </v-icon>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text"
            >ندارد</v-card-text
          >
        </template>
        <template v-slot:item.entrepot.id="{ item }">
          <v-btn
            v-if="item.entrepot"
            :loading="loading"
            class="ma-0 pa-1 text-right"
            :color="
              item.entrepot.type === 'remittance'
                ? 'pink'
                : item.entrepot.type === 'receipt'
                ? 'teal'
                : 'blue'
            "
            plain
            small
            @click="entrepot_(item.entrepot)"
          >
            {{ $t(item.entrepot.type) }} {{ $t("entrepot") }}
            {{
              item.entrepot && item.entrepot.entrepot ? item.entrepot.entrepot.name : ""
            }}
            <br />
            {{ item.entrepot.id }}
          </v-btn>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{
            $t("haveNot")
          }}</v-card-text>
        </template>
        <template v-slot:item.branch.name="{ item }">
          <v-card-text class="pa-0 text-caption" v-if="item.branch">
            {{ item.branch.name }}
          </v-card-text>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
            {{ $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status ? item.last_status.status.name : "" }}
            </span>
          </v-chip>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{
            $t("haveNot")
          }}</v-card-text>
        </template>
        <template v-slot:item.due_date="{ item }">
          {{ item.due_date ? item.due_date : "" }}
        </template>
        <template v-slot:item.tags="{ item }">
          <v-container
            v-if="item.tags.length > 0"
            class="pa-0 d-flex gap-1"
            style="flex-wrap: wrap; max-width: 165px !important; min-width: 120px"
          >
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              @click="edit(item)"
              label
              small
              class="px-1 mb-1"
              style="
                background: transparent;
                border: 1px solid #959494;
                border-radius: 10px !important;
              "
            >
              <span class="px-1">
                {{ tag.text }}
              </span>
            </v-chip>
          </v-container>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{
            $t("haveNot")
          }}</v-card-text>
        </template>
        <template v-slot:item.taxid="{ item }">
          <v-chip
            v-if="item.tax_payer == null || item.tax_payer == undefined"
            small
            color="secondary"
          >
            {{ resolveSubmitionDeadline(item.date) }}
          </v-chip>
          <v-card-text
            v-if="item.tax_payer && item.tax_payer.taxid"
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ item.tax_payer.taxid }}
          </v-card-text>
          <v-card-text
            v-if="item.tax_payer && item.tax_payer.taxid == null"
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.system_status="{ item }">
          <v-chip
            v-if="
              item.tax_payer &&
              item.tax_payer.status != 'error' &&
              item.tax_payer.status != 'sent' &&
              item.tax_payer.status != 'done' &&
              item.tax_payer.status != 'editSent' &&
              item.tax_payer.status != 'removeSent'
            "
            small
            :color="resolveTaxPayerStatusColor(item.tax_payer)"
            @click="openTaxPayerStatus(item.tax_payer)"
          >
            {{ resolveTaxPayerStatus(item.tax_payer) }}
          </v-chip>
          <v-chip
            v-if="
              item.tax_payer &&
              (item.tax_payer.status == 'error' ||
                item.tax_payer.status == 'sent' ||
                item.tax_payer.status == 'done' ||
                item.tax_payer.status == 'editSent' ||
                item.tax_payer.status == 'removeSent')
            "
            small
            :color="
              item.tax_payer.status == 'error'
                ? 'error'
                : item.tax_payer.status == 'sent'
                ? 'primary'
                : item.tax_payer.status == 'done'
                ? 'success'
                : item.tax_payer.status == 'editSent'
                ? 'warning'
                : item.tax_payer.status == 'removeSent'
                ? 'error'
                : ''
            "
          >
            {{
              item.tax_payer.status == "error"
                ? $t("error-in-sending-invoice")
                : item.tax_payer.status == "sent"
                ? $t("shipped")
                : item.tax_payer.status == "done"
                ? $t("confirmed")
                : item.tax_payer.status == "editSent"
                ? $t("edited")
                : item.tax_payer.status == "removeSent"
                ? $t("cenceled")
                : $t("undefined")
            }}
          </v-chip>
        </template>
        <template v-slot:item.content="{ item }">
          <v-card-text
            v-if="
              item.integrator.length == 0 ||
              (item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'woocommerceInvoice') &&
                item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'digikalaInvoice') &&
                item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'sazitoInvoice') &&
                item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'webziInvoice') &&
                item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'portalInvoice') &&
                item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'basalamInvoice') &&
                item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'mixinInvoice') &&
                item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'magnetInvoice') &&
                item.integrator.length != 0 &&
                !item.integrator.find((item) => item.key == 'snapshopInvoice') &&
                item.content == null &&
                item.custom_fields.length == 0)
            "
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
          <!--woocommerce id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'woocommerceInvoice') &&
              item.integrator.find((item) => item.key == 'woocommerceInvoice').value !=
                null
            "
          >
            <img src="@/assets/woo.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'woocommerceInvoice') &&
                item.integrator.find((item) => item.key == 'woocommerceInvoice').value !=
                  null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'woocommerceInvoice').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "woocommerceInvoice").value }}
            </v-card-text>
          </v-container>
          <!--digikala id-->
          <v-container
            v-if="
              item.integrator &&
              item.integrator.some((i) => i.key === 'digikalaInvoice' && i.value)
            "
            class="pa-0 d-flex flex-column gap-1"
          >
            <v-container
              v-for="(dg, index) in item.integrator.filter(
                (i) => i.key === 'digikalaInvoice' && i.value
              )"
              :key="index"
              class="pa-0 d-flex align-center gap-1"
            >
              <img src="@/assets/digikala.png" style="width: 20px; border-radius: 0" />
              <v-card-text class="pa-0 text-caption">
                {{ $t("id") }}:
                <span v-if="dg.panel != null"> ({{ dg.panel.abr_name }}) </span>
              </v-card-text>
              <v-card-text
                v-clipboard:copy="dg.value"
                @click="copied"
                class="pa-0 text-caption text-disable secondary--text"
                style="cursor: pointer"
              >
                {{ dg.value }}
              </v-card-text>
            </v-container>
          </v-container>
          <!--basalam id-->
          <v-container
            v-if="
              item.integrator &&
              item.integrator.some((i) => i.key === 'basalamInvoice' && i.value)
            "
            class="pa-0 d-flex flex-column gap-1"
          >
            <v-container
              v-for="(basalam, index) in item.integrator.filter(
                (i) => i.key === 'basalamInvoice' && i.value
              )"
              :key="index"
              class="pa-0 d-flex align-center gap-1"
            >
              <img src="@/assets/basalam.png" style="width: 20px; border-radius: 0" />
              <v-card-text class="pa-0 text-caption">
                {{ $t("id") }}:
                <span v-if="basalam.panel != null"> ({{ basalam.panel.abr_name }}) </span>
              </v-card-text>
              <v-card-text
                v-clipboard:copy="basalam.value"
                @click="copied"
                class="pa-0 text-caption text-disable secondary--text"
                style="cursor: pointer"
              >
                {{ basalam.value }}
              </v-card-text>
            </v-container>
          </v-container>
          <!--sazito id-->
          <v-container
            v-if="
              item.integrator &&
              item.integrator.some((i) => i.key === 'sazitoInvoice' && i.value)
            "
            class="pa-0 d-flex flex-column gap-1"
          >
            <v-container
              v-for="(sz, index) in item.integrator.filter(
                (i) => i.key === 'sazitoInvoice' && i.value
              )"
              :key="index"
              class="pa-0 d-flex align-center gap-1"
            >
              <img src="@/assets/sazito(1).png" style="width: 20px; border-radius: 0" />
              <v-card-text class="pa-0 text-caption">
                {{ $t("id") }}:
                <span v-if="sz.panel != null"> ({{ sz.panel.abr_name }}) </span>
              </v-card-text>
              <v-card-text
                v-clipboard:copy="sz.value"
                @click="copied"
                class="pa-0 text-caption text-disable secondary--text"
                style="cursor: pointer"
              >
                {{ sz.value }}
              </v-card-text>
            </v-container>
          </v-container>
          <!--magnet id-->
          <v-container
            v-if="
              item.integrator &&
              item.integrator.some((i) => i.key === 'magnetInvoice' && i.value)
            "
            class="pa-0 d-flex flex-column gap-1"
          >
            <v-container
              v-for="(mg, index) in item.integrator.filter(
                (i) => i.key === 'magnetInvoice' && i.value
              )"
              :key="index"
              class="pa-0 d-flex align-center gap-1"
            >
              <img
                src="@/assets/integrators/logo-magnet.png"
                style="width: 20px; border-radius: 0"
              />
              <v-card-text class="pa-0 text-caption">
                {{ $t("id") }}:
                <span v-if="mg.panel != null"> ({{ mg.panel.abr_name }}) </span>
              </v-card-text>
              <v-card-text
                v-clipboard:copy="mg.value"
                @click="copied"
                class="pa-0 text-caption text-disable secondary--text"
                style="cursor: pointer"
              >
                {{ mg.value }}
              </v-card-text>
            </v-container>
          </v-container>
          <!--mixin id-->
          <v-container
            v-if="
              item.integrator &&
              item.integrator.some((i) => i.key === 'mixinInvoice' && i.value)
            "
            class="pa-0 d-flex flex-column gap-1"
          >
            <v-container
              v-for="(mix, index) in item.integrator.filter(
                (i) => i.key === 'mixinInvoice' && i.value
              )"
              :key="index"
              class="pa-0 d-flex align-center gap-1"
            >
              <img
                src="@/assets/integrators/mixin.png"
                style="width: 20px; border-radius: 0"
              />
              <v-card-text class="pa-0 text-caption">
                {{ $t("id") }}:
                <span v-if="mix.panel != null"> ({{ mix.panel.abr_name }}) </span>
              </v-card-text>
              <v-card-text
                v-clipboard:copy="mix.value"
                @click="copied"
                class="pa-0 text-caption text-disable secondary--text"
                style="cursor: pointer"
              >
                {{ mix.value }}
              </v-card-text>
            </v-container>
          </v-container>
          <!--snapshop id-->
          <v-container
            v-if="
              item.integrator &&
              item.integrator.some((i) => i.key === 'snapshopInvoice' && i.value)
            "
            class="pa-0 d-flex flex-column gap-1"
          >
            <v-container
              v-for="(snap, index) in item.integrator.filter(
                (i) => i.key === 'snapshopInvoice' && i.value
              )"
              :key="index"
              class="pa-0 d-flex align-center gap-1"
            >
              <img
                src="@/assets/integrators/snapShop.png"
                style="width: 20px; border-radius: 0"
              />
              <v-card-text class="pa-0 text-caption">
                {{ $t("id") }}:
                <span v-if="snap.panel != null"> ({{ snap.panel.abr_name }}) </span>
              </v-card-text>
              <v-card-text
                v-clipboard:copy="snap.value"
                @click="copied"
                class="pa-0 text-caption text-disable secondary--text"
                style="cursor: pointer"
              >
                {{ snap.value }}
              </v-card-text>
            </v-container>
          </v-container>
          <!--webzi id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'webziInvoice') &&
              item.integrator.find((item) => item.key == 'webziInvoice').value != null
            "
          >
            <img src="@/assets/webzi.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'webziInvoice') &&
                item.integrator.find((item) => item.key == 'webziInvoice').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'webziInvoice').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "webziInvoice").value }}
            </v-card-text>
          </v-container>
          <!--markito id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'markitoInvoice') &&
              item.integrator.find((item) => item.key == 'markitoInvoice').value != null
            "
          >
            <img src="@/assets/markito.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'markitoInvoice') &&
                item.integrator.find((item) => item.key == 'markitoInvoice').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'markitoInvoice').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "markitoInvoice").value }}
            </v-card-text>
          </v-container>
          <!--portal id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'portalInvoice') &&
              item.integrator.find((item) => item.key == 'portalInvoice').value != null
            "
          >
            <img
              src="@/assets/portal.png"
              style="width: 15px; height: 15px; border-radius: 0"
            />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'portalInvoice') &&
                item.integrator.find((item) => item.key == 'portalInvoice').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'portalInvoice').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "portalInvoice").value }}
            </v-card-text>
          </v-container>
          <!--custom filds-->
          <div v-if="item.custom_fields" class="pt-1">
            <v-chip
              v-for="(field, index) in item.custom_fields"
              :key="index"
              label
              color="primary"
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text"> {{ field.key }} : {{ field.value }} </span>
            </v-chip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{
              item.content
                ? item.content.substr(0, item.deleted_at ? item.content.length : 20)
                : ""
            }}
            {{
              !item.deleted_at && item.content && item.content.length > 20 ? "..." : ""
            }}
          </v-card-text>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                <v-card-text class="pa-0 text-caption">
                  {{ item.user.firstname }} {{ item.user.lastname }}
                </v-card-text>
              </div>
              <v-card-text
                v-else
                class="pa-0 text-caption text-disable secondary--text"
                >{{ $t("haveNot") }}</v-card-text
              >
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.price.NetPrice="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ $numberFormat((item.price ? item.price.NetPrice : 0)) }} {{ item.currency.symbol }}
          </v-card-text>
        </template>
        <template v-slot:item.plan="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.plan"
              color="primary"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ (item.plan ? item.plan.plan.name : '') }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>-->
        <template v-slot:body.append>
          <tr>
            <td :colspan="`${isMobile ? 6 : Number(showHeaders.length)}`">
              <div style="width: 100%" class="pa-1">
                <strong>{{ $t("sumInPage") }}</strong
                >:
                <v-chip color="pOrrange" class="px-1 me-1" outlined>
                  <span class="px-1" style="font-size: 11px">
                    {{ $t("netAmount") }}:{{
                      $numberFormat(totals.price.toFixed($store.state.currency.decimal))
                    }}
                  </span>
                </v-chip>
                <v-chip color="pink" class="px-1 me-1" outlined>
                  <span class="px-1" style="font-size: 11px">
                    {{ $t("discount") }}:{{
                      $numberFormat(
                        totals.discount.toFixed($store.state.currency.decimal)
                      )
                    }}
                  </span>
                </v-chip>
                <v-chip color="secondary" class="px-1 me-1" outlined>
                  <span class="px-1" style="font-size: 11px">
                    {{ $t("tax") }}:{{
                      $numberFormat(totals.tax.toFixed($store.state.currency.decimal))
                    }}
                  </span>
                </v-chip>
                <v-chip v-if="hasCustomerClub" color="teal" class="px-1 me-1" outlined>
                  <span class="px-1" style="font-size: 11px">
                    {{ $t("club-credit") }}:{{
                      $numberFormat(totals.credit.toFixed($store.state.currency.decimal))
                    }}
                  </span>
                </v-chip>
                <v-chip color="primary" class="px-1 me-1">
                  <span class="px-1 white--text" style="font-size: 11px">
                    {{ $t("clearAmount") }}:{{
                      $numberFormat(
                        totals.sumNetAmount.toFixed($store.state.currency.decimal)
                      )
                    }}
                  </span>
                </v-chip>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="invoicePrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="invoicePrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint :id-prop="printId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
      :draggable="true"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <autocomplete
              v-model="account"
              :title="$t('customer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <status v-model="sellStatus" :hideconfig="true" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="category"
              :title="$t('category')"
              type="accountCategory"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="lockStatus"
              :label="$t('lockStatusDocuments')"
              :items="lockStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <v-select
              v-model="payedStatus"
              :label="$t('payed-status')"
              :items="payedStatuses"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="label"
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromTime"
                v-model="fromTime"
                :label="$t('from-hour')"
                outlined
                dense
                clearable
                readonly
              />
              <date-picker
                v-model="fromTime"
                element="fromTime"
                type="time"
                :locale="$store.state.date_locale"
                :format="'HH:mm'"
                :display-format="'HH'"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toTime"
                v-model="toTime"
                :label="$t('to-hour')"
                outlined
                dense
                clearable
                readonly
              />
              <date-picker
                v-model="toTime"
                element="toTime"
                type="time"
                :locale="$store.state.date_locale"
                :format="'HH:mm'"
                :display-format="'HH'"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId1"
                v-model="fromDueDate"
                :label="$t('fromDueDate')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="fromDueDate"
                element="fromId1"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId1"
                v-model="toDueDate"
                :label="$t('toDueDate')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="toDueDate"
                element="toId1"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
        </v-row>
        <v-row v-if="!isMobile && customFieldsPermission" class="mx-0">
          <custom-fields
            v-model="customFields"
            :value="customFields"
            type-prop="invoiceCustomFields"
            :multiple="true"
            class="px-4"
          />
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col cols="6" class="pa-0 py-1">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="pa-0 py-1">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="invoice"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="documentsDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="documentsDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <div align="center" class="px-4">
          <v-btn color="primary" block elevation="0" style="font-size: 16px">
            {{ documentsTitleDialog }}
          </v-btn>
        </div>
        <v-col class="mt-0 pt-0 pr-7">
          <file-picker
            ref="refFilePicker"
            :label="$t('addDocuments')"
            :multiple="false"
            :hide-remove="true"
            type-prop="invoice"
            :val="documents ? documents : null"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="groupPrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="40%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="groupPrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col class="text-right">
            <v-radio-group v-model="printType">
              <v-radio value="officialInvoice">
                <template v-slot:label>
                  <div>{{ $t("officialInvoice") }}</div>
                </template>
              </v-radio>
              <v-radio value="invoice">
                <template v-slot:label>
                  <div>{{ $t("generalInvoice") }}</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn color="primary" :loading="loading" @click="groupPrintInvoice">
            {{ $t("print") }}
          </v-btn>
          <v-spacer />
          <v-btn color="grey" @click="groupPrintDialog = !groupPrintDialog">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--checkAverageDialog-->
    <v-dialog
      v-model="checkAverageDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="600"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-1">{{ $t("invoice-list") }}</v-card-text>
          <v-icon size="15" @click="checkAverageDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-space-between align-end my-6">
          <div>
            <v-card-text class="pa-0 text-body-2">
              {{ $t("count") }} : {{ selectedCheck ? selectedCheck.length : "" }}
              {{ $t("numbers") }}
            </v-card-text>
            <v-card-text class="pa-0 text-body-2 mt-1">
              {{ $t("sumAmount") }} : {{ checksTotal ? $numberFormat(checksTotal) : 0 }}
              {{ $t("rial") }}
            </v-card-text>
            <v-card-text class="pa-0 text-body-1 mt-1">
              {{ $t("invoice-count") }} :
              {{
                checkAverageDate ? checkAverageDate.split("T")[0].replace(/-/g, "/") : ""
              }}
            </v-card-text>
          </div>
          <div class="d-flex justify-end flex-column">
            <v-btn
              color="primary"
              height="32"
              class="mb-4 mr-12"
              :loading="loading"
              @click="fetchCheckAverageSecond"
            >
              {{ $t("invoice-head-recalculation") }}
            </v-btn>
            <template>
              <v-text-field
                id="selectedDate"
                v-model="selectedDate"
                :label="$t('date')"
                append-icon="mdi-calendar"
                :rules="[(v) => !!v || $t('is-required')]"
                outlined
                dense
                clearable
                :class="{ 'mt-5': isMobile }"
              />
              <date-picker
                v-model="selectedDate"
                element="selectedDate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </div>
        </v-container>
        <v-data-table
          :headers="checkAverageHeaders"
          :items="checkAverageItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage"
          style="background-color: #eeeeee"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">
              {{ index + 1 }}
            </v-card-text>
          </template>
          <template v-slot:item.checkNumber="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.number ? item.number : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.detailsInvoice="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.customer ? item.customer.name : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.dueDate="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.due_date ? item.due_date : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-card-text v-if="item.price" class="pa-0 text-caption">
              {{ $numberFormat(item.price.price) }} {{ item.currency.name }}
            </v-card-text>
            <v-card-text v-else class="pa-0 text-caption">
              {{ $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:header.edit="{ header }">
            <div @click="openCheckDeleteDialog('all')">
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
              />
            </div>
          </template>
          <template v-slot:item.edit="{ item, index }">
            <div @click="openCheckDeleteDialog('single', item.id)">
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
              />
            </div>
          </template>
        </v-data-table>
        <v-card-text
          v-if="isThereInvoiceWithoutId"
          class="pa-0 text-body-2 mt-1"
          style="color: #ff5252"
        >
          {{ $t("only invoices with due-date can be calculated") }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--check delete dialog-->
    <v-dialog
      v-model="checkDeleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{
            deleteAllCheck
              ? $t("are you sure you want to delete all items?")
              : $t("Are you sure you want to delete this item ?")
          }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="error" height="32" @click="deleteCheck">
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="checkDeleteDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--tax payer confirmation-->
    <v-dialog
      v-model="taxPayerConfirmDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="400"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">
            {{ $t("are you share you want to send these items to taxpayer system ?") }}
          </v-card-text>
          <v-icon size="15" @click="taxPayerConfirmDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="primary" height="32" @click="sendToTaxPayer" :loading="loading">
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="taxPayerConfirmDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--Invoices with errors-->
    <v-dialog
      v-model="invoiceErrorDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="750"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{ $t("invoice errors while submit to taxpayer system") }}
          </v-card-text>
          <v-icon size="15" @click="invoiceErrorDialog = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2">
          {{
            $t(
              "the following invoices encountered an error while being sent to the system"
            )
          }}
        </v-card-text>
        <v-data-table
          :headers="invoiceErrorHeaders"
          :items="invoiceErrorItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage errors mt-5"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
          </template>
          <template v-slot:item.invoiceNumber="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.invoice.number ? "#" + item.invoice.number : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.invoice.price && item.invoice.price.price && item.invoice.currency
                  ? $numberFormat(
                      item.invoice.price.price,
                      item.invoice.currency.decimal
                    ) +
                    " " +
                    item.invoice.currency.symbol
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
          <template v-slot:item.detailsInvoice="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.invoice.customer && item.invoice.customer.name
                  ? item.invoice.customer.name
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
          <template v-slot:item.registerDate="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.invoice.date ? item.invoice.date : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn text @click="showErrorDetails(item)">
              {{ $t("show-details") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!--Invoice errors with details-->
    <v-dialog
      v-model="invoiceErrorDetailsDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="550"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{
              $t("errors-invoice") +
              (selectedInvoiceItem && selectedInvoiceItem.invoice.number
                ? selectedInvoiceItem.invoice.number + "#"
                : $t("haveNot"))
            }}
          </v-card-text>
          <v-icon size="15" @click="invoiceErrorDetailsDialog = false">mdi-close</v-icon>
        </v-container>
        <v-data-table
          :headers="invoiceErrorDetailsHeaders"
          :items="selectedInvoiceErrors"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage errors mt-5"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
          </template>
          <template v-slot:item.systemErrors="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.code && item.message
                  ? "(" + item.code + ")" + " " + item.message
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn text @click="editInvoice">
              {{ $t("edit-invoice") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!--taxpayer show status dialog-->
    <v-dialog
      v-model="taxPayerStatusReviewDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="550"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center mb-4">
          <v-card-text class="pa-0 text-body-1">
            {{
              $t("errors-invoice") +
              (taxPayerStatusError ? taxPayerStatusError.head_id + "#" : $t("haveNot"))
            }}
          </v-card-text>
          <v-icon size="15" @click="taxPayerStatusReviewDialog = false">mdi-close</v-icon>
        </v-container>
        <v-data-table
          :headers="taxPayerStatusErrorHeaders"
          :items="taxPayerStatusErrorItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          fixed-header
          class="checkAverage errors mt-5"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
          </template>
          <template v-slot:item.systemErrors="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{
                item.code && item.message
                  ? "(" + item.code + ")" + " " + item.message
                  : $t("haveNot")
              }}
            </v-card-text>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- alert type dialog -->
    <v-dialog
      v-model="alertDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="450"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-end mb-5">
          <v-icon size="15" @click="alertDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-center">
            <span class="text-body-1">{{ alertDialogText }}</span>
            <br /><br />
            <span v-if="!successAlert" class="text-body-2">{{
              $t("taxPayer system is working on this invoice")
            }}</span>
          </v-card-text>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center mt-5">
          <v-btn @click="alertDialog = false" color="error" height="32">
            {{ $t("close") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <payed-details-dialog v-model="payedDialog" :item="selectedPayedItem" />

    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import Task from "../task/task";
import Invoicprint from "./print";
import General from "../../../../Mixins/general";
import Upload from "../../components/general/upload/upload";
import filePicker from "../../components/general/filePicker/index";
import TaxPayerContent from "./taxPayerContent.vue";
import customFields from "../../components/general/customFields/index.vue";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import PayedDetailsDialog from "./partial/PayedDetailsDialog.vue";
import moment from "moment-jalaali";

export default {
  name: "InvoiceList",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    dialogComponent: () => import("../../components/general/dialog/index"),
    Upload,
    customFields,
    filePicker,
    TaxPayerContent,
    Invoicprint,
    Task,
    MyIcon,
    PayedDetailsDialog,
  },
  mixins: [General],
  props: ["input", "refId", "typeProp", "accountProp", "mobileShow"],
  data: () => ({
    selected: [],
    printHeaders: [],
    datatableStore: false,
    summary: null,
    registerar: null,
    removedInvoices: null,
    groupPrintDialog: false,
    invoicePrintDialog: false,
    printDialog: false,
    deletDialog: false,
    uploadDialog: false,
    documentsDialog: false,
    documents: false,
    documentsTitleDialog: "",
    printType: "invoice",
    dialogData: null,
    entrepot: null,
    category: null,
    account: null,
    currencyFilter: null,
    fromAmount: null,
    toAmount: null,
    fromNumber: null,
    toNumber: null,
    fromDate: null,
    toDate: null,
    fromDueDate: null,
    toDueDate: null,
    printId: null,
    showSelect: true,
    filter: false,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    customFields: null,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    selectedHeadersTemp: [],
    headersMap: null,
    pageCount: 1,
    page: 1,
    excelItems: [],
    selectedCheck: [],
    today: null,
    checkAverageDialog: false,
    selectedDate: null,
    today: null,
    checkAverageItems: null,
    checkDeleteDialog: false,
    deleteAllCheck: false,
    selectedCheckID: null,
    checksID: [],
    checksTotal: 0,
    checkAverageDate: null,
    invoice_without_due_date: null,
    isThereInvoiceWithoutId: false,
    taxPayerSelectedItems: null,
    taxPayerConfirmDialog: false,
    invoiceErrorDialog: false,
    invoiceErrorHeaders: null,
    invoiceErrorItems: null,
    invoiceErrorDetailsDialog: false,
    selectedInvoiceItem: null,
    selectedInvoiceErrors: null,
    invoiceErrorDetailsHeaders: null,
    taxPayerStatusReviewDialog: false,
    taxPayerStatusError: null,
    taxPayerStatusErrorItems: null,
    taxPayerStatusErrorHeaders: null,
    alertDialog: false,
    alertDialogText: null,
    successAlert: false,
    isUserHasTaxPayer: false,
    removeType: null,
    products: null,
    payedStatus: null,
    fromTime: null,
    toTime: null,
    payedDialog: false,
    selectedPayedItem: null,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type !== "sell" && app.type !== "returnSell") {
          if (s.value === "pre_invoice") {
          } else {
            if (s.align != "d-none") {
              return app.selectedHeaders.includes(s);
            }
          }
        } else {
          if (s.align != "d-none") {
            return app.selectedHeaders.includes(s);
          }
        }
      });
    },
    totals: function () {
      // var total = this.items.map(function (value, key) {
      //   app.remove(value, key)
      // })
      // var app = this
      // app.excelItems = []
      const totals = this.items.reduce(
        (acc, d) => {
          acc.price += d.price
            ? parseFloat(d.price.price) +
              parseFloat(d.discount ? d.discount : 0) -
              parseFloat(d.tax ? d.tax : 0)
            : 0;
          acc.sumNetAmount += d.price ? parseFloat(d.price.price) : 0;
          acc.discount += parseFloat(d.discount);
          acc.tax += parseFloat(d.tax);
          acc.credit += parseFloat(d.credit || 0);
          return acc;
        },
        {
          sumNetAmount: 0,
          price: 0,
          discount: 0,
          tax: 0,
          credit: 0,
        }
      );
      return totals;
    },
    payedStatuses() {
      return [
        { label: this.$t("payed"), value: "payed" },
        { label: this.$t("not-payed"), value: "notPayed" },
      ];
    },
  },
  watch: {
    selectedHeaders(val) {},
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      // taxPayerSystem
      this.taxPayerSelectedItems = this.selected.filter((item) => {
        const created = moment(item.date, "jYYYY/jMM/jDD");
        const now = moment();

        // special windows
        const esfStart = moment("1404/12/01", "jYYYY/jMM/jDD");
        const esfEnd = moment("1404/12/29", "jYYYY/jMM/jDD");
        const esfDeadline = moment("1405/01/31", "jYYYY/jMM/jDD");
        //change this for ordibehesht
        const farStart = moment("1405/01/01", "jYYYY/jMM/jDD");
        const farEnd = moment("1405/02/15", "jYYYY/jMM/jDD");
        const farDeadline = moment("1405/02/30", "jYYYY/jMM/jDD");

        // 1) esf window check
        if (created.isBetween(esfStart, esfEnd, undefined, "[]")) {
          return now.isSameOrBefore(esfDeadline, "day");
        }

        // 2) far window check
        if (created.isBetween(farStart, farEnd, undefined, "[]")) {
          return now.isSameOrBefore(farDeadline, "day");
        }

        // 3) normal 30‑day rule
        return now.diff(created, "days") <= 15;
      });

      // get Average
      const validItems = this.selected.filter((item) => item.due_date != null);
      this.selectedCheck = validItems;
      this.invoice_without_due_date = this.selected.filter(
        (item) => item.due_date == null
      );

      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      app.getItems();
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options?.sortBy?.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers?.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    accountProp(val) {
      this.getItems();
    },
    checkAverageDialog(val) {
      if (val) {
        this.selectedDate = this.today;
        this.checkAverageItems = this.selectedCheck;
      }
    },
    checkAverageItems(val) {
      this.selected = val;
      this.resolveChecksTotal();
    },
  },
  activated() {
    // this.getItems()
  },
  beforeMount() {
    this.isUserHasTaxPayer = JSON.parse(localStorage.getItem("hasTaxPayer"));

    if (this.$route.name === "purchaseList") {
      this.type = "purchase";
    }
    if (this.$route.name === "presaleList") {
      this.type = "presale";
    }
    if (this.$route.name === "sellList") {
      this.type = "sell";
    }
    if (this.$route.name === "returnPurchaseList") {
      this.type = "returnPurchase";
    }
    if (this.$route.name === "returnSellList") {
      this.type = "returnSell";
    }
    if (this.$route.name === "sellTaxPayer") {
      this.type = "sell";
    }
    if (this.$route.name === "removedInvoices") {
      this.type = "removedInvoices";
      this.removedInvoices = "active";
    }
    if (this.typeProp) {
      this.type = this.typeProp;
    }

    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "id",
      },
      {
        text: this.$t("number"),
        value: "number",
      },
      {
        text: this.$t("detailsName"),
        value: "customer.name",
      },
      {
        text: this.$t("mobile"),
        value: "customer.mobile",
      },
      {
        text: this.$t("date"),
        value: "date",
      },
      {
        text: this.$t("NetAmount"),
        value: "price.NetPrice",
        sum: true,
      },
      {
        text: this.$t("discount"),
        value: "discount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("tax"),
        value: "tax",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("club-credit"),
        value: "credit",
        sum: true,
        type: "number",
        align: this.hasCustomerClub ? "center" : "d-none",
      },
      {
        text: this.$t("finalAmount"),
        value: "price.price",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumPayments"),
        value: "payed.paymentsAmount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumChecks"),
        value: "payed.checksAmount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("sumPayed"),
        value: "payed.amount",
        sum: true,
        type: "number",
      },
    ];
    if (!this.hasCustomerClub) {
      this.printHeaders = this.printHeaders.filter((h) => h.value !== "credit");
    }
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.checkAverageHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 25,
      },
      {
        text: this.$t("invoic-number"),
        align: "start",
        sortable: false,
        value: "checkNumber",
      },
      {
        text: this.$t("detailsInvoice"),
        align: "start",
        sortable: false,
        value: "detailsInvoice",
      },
      {
        text: this.$t("dueDate"),
        align: "start",
        sortable: false,
        value: "dueDate",
      },
      {
        text: this.$t("amount"),
        align: "start",
        sortable: false,
        value: "amount",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
      },
    ];
    this.invoiceErrorHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("invoic-number"),
        align: "start",
        sortable: false,
        value: "invoiceNumber",
      },
      {
        text: this.$t("amount"),
        align: "start",
        sortable: false,
        value: "amount",
      },
      {
        text: this.$t("detailsInvoice"),
        align: "start",
        sortable: false,
        value: "detailsInvoice",
      },
      {
        text: this.$t("register-date"),
        align: "start",
        sortable: false,
        value: "registerDate",
      },
      {
        text: this.$t("action"),
        align: "start",
        sortable: false,
        value: "action",
      },
    ];
    this.invoiceErrorDetailsHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("system-errors"),
        align: "start",
        sortable: false,
        value: "systemErrors",
      },
      {
        text: this.$t("action"),
        align: "start",
        sortable: false,
        value: "action",
      },
    ];
    this.taxPayerStatusErrorHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("system-errors"),
        align: "start",
        sortable: false,
        value: "systemErrors",
      },
    ];
  },
  mounted() {
    this.setToday();
    this.getPermissions();

    this.headers = [
      {
        text: this.$t("action"),
        align: "start",
        sortable: false,
        value: "action",
        width: 20,
      },
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("id"),
        sortable: true,
        value: "id",
        table: "invoice_header.id",
        width: 80,
      },
      {
        text: this.$t("number") + " " + this.$t("document"),
        sortable: false,
        value: "doc_header.number",
        width: 70,
      },
      {
        text: this.$t("detailsName"),
        sortable: false,
        value: "customer.name",
        width: 150,
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "invoice_header.date",
        width: 70,
      },
      {
        text: this.$t("finalAmount"),
        sortable: false,
        value: "price.price",
        width: 100,
      },
      {
        text: this.$t("sumPayed"),
        sortable: false,
        value: "payed.amount",
        width: 100,
      },
      {
        text: this.$t("preInvoice"),
        sortable: false,
        value: "pre_invoice",
        table: "doc_header.pre_invoice",
        width: 50,
      },
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot.id",
        width: 70,
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
        width: 100,
      },
      {
        text: this.$t("status"),
        sortable: false,
        value: "last_status.status_id",
        table: "doc_header.buyer_id",
        width: 90,
      },
      {
        text: this.$t("dueDate"),
        sortable: false,
        value: "due_date",
        width: 150,
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
        width: 150,
      },
      {
        text: this.$t("taxId"),
        sortable: false,
        value: "taxid",
        width: 150,
        align:
          this.isUserHasTaxPayer && (this.type == "sell" || this.type == "returnSell")
            ? "center"
            : "d-none",
      },
      {
        text: this.$t("system-status"),
        sortable: false,
        value: "system_status",
        width: 150,
        align:
          this.isUserHasTaxPayer && (this.type == "sell" || this.type == "returnSell")
            ? "center"
            : "d-none",
      },
      {
        text: this.$t("other"),
        sortable: false,
        value: "content",
        table: "products.description",
        width: 200,
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
        width: 100,
      },
    ];

    this.selectedHeaders = this.headers;
  },
  methods: {
    openPayedDetailsDialog(item) {
      this.selectedPayedItem = item;
      this.payedDialog = true;
    },
    resolveAnnulmentBtnVisibility(item) {
      if (
        (item.tax_payer != null &&
          item.tax_payer.state == "new" &&
          item.tax_payer.status == "SUCCESS") ||
        (item.tax_payer != null &&
          item.tax_payer.state == "edit" &&
          item.tax_payer.status == "SUCCESS") ||
        (item.tax_payer != null &&
          item.tax_payer.state == "edit" &&
          item.tax_payer.status == "FAILED") ||
        (item.tax_payer != null &&
          item.tax_payer.state == "delete" &&
          item.tax_payer.status == "FAILED")
      ) {
        return true;
      }
    },
    resolveDeleteBtnVisibility(item) {
      if (
        item.tax_payer == null ||
        item.tax_payer == undefined ||
        (item.tax_payer != null &&
          item.tax_payer.state == "new" &&
          item.tax_payer.status == "FAILED") ||
        (item.tax_payer != null &&
          item.tax_payer.state == "delete" &&
          item.tax_payer.status == "SUCCESS")
      ) {
        return true;
      }
    },
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        const shamsiYear = m.jYear();
        const shamsiMonth = String(m.jMonth() + 1).padStart(2, "0");
        const shamsiDay = String(m.jDate()).padStart(2, "0");
        this.today = `${shamsiYear}/${shamsiMonth}/${shamsiDay}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        this.today = m.format("YYYY/MM/DD");
      }
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        const tags = d.tags.map((item) => item.text).join(",");
        app.excelItems.push({
          id: d.id,
          type: app.$t(d.type),
          number: d.number,
          customer: d.customer ? d.customer.name : null,
          mobile: d.customer ? d.customer.mobile : null,
          date: d.date,
          price: app.$numberFormat(d.price ? d.price.price : 0),
          discount: app.$numberFormat(d.discount),
          tax: app.$numberFormat(d.tax),
          warehouse: d.entrepot && d.entrepot.entrepot ? d.entrepot.entrepot.name : "",
          internal_code:
            d.branch && d.branch.internal_code
              ? d.branch.internal_code
              : app.$t("haveNot"),
          financial_code:
            d.customer &&
            d.customer.financial_code &&
            d.customer.financial_code !== "null"
              ? d.customer.financial_code
              : "",
          payment: d.payed ? app.$numberFormat(d.payed.amount) : "",
          content: d.content,
          dueDate: d.due_date ? d.due_date : "",
          tags: d.tags ? tags : null,
          integrator:
            d.integrator && d.integrator.length > 0
              ? app.$t(d.integrator[0].key) +
                " = " +
                d.integrator[0].value +
                " | " +
                d.integrator[0].number
              : "",
          user: d.user ? d.user.name : "",
        });
      });
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    // add unlock group send type
    unlockGroup(type = "unlock") {
      this.lockGroup(type);
    },
    reviewDigikalaOrder() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            reviewDigikalaOrder: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    refreshRemovedItem() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            refreshRemovedInvoices: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    openUploadDialog(item) {
      this.uploadDialog = true;
    },
    openDocumentsDialog(item) {
      this.documentsTitleDialog =
        this.$t("documents") + " " + this.$t(item.type) + " " + item.number;
      this.documents = item.attachments;
      this.documentsDialog = true;
    },
    copyInvoice(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice/" + item.uid + "/edit", {
          params: {
            id: item.uid,
          },
        })
        .then((res) => {
          res = res.data;
          const meta = {
            customer: res.customer,
            branch: res.branch,
            date: res.date,
            entrepot: res.entrepot ? res.entrepot.entrepot : null,
          };
          app.$router.push({
            name: app.type,
            params: {
              itemsProp: res.article,
              metaProp: meta,
            },
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    entrepot_(item) {
      this.$router.push({ name: item.type + "Edit", params: { id: item.id } });
    },
    openComponent(component, id) {
      if (this.$store.state.permissions.includes("customerEdit")) {
        this.dialogData = {
          name: component,
          id: id,
        };
        this.innerComponent = true;
      }
    },
    openDeleteDialog(item, type) {
      this.deleteItem = item;
      this.deletDialog = true;
      this.removeType = type;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      if (!this.removedInvoices) {
        if (item.tax_payer && item.tax_payer.state) {
          if (
            (item.tax_payer.state == "new" && item.tax_payer.status == "PENDING") ||
            (item.tax_payer.state == "edit" && item.tax_payer.status == "PENDING") ||
            (item.tax_payer.state == "delete" && item.tax_payer.status == "PENDING")
          ) {
            // show a dialog
            this.alertDialog = true;
            this.alertDialogText =
              this.$t("your invoice is pending to") +
              (item.tax_payer.state == "new"
                ? this.$t("is-sending")
                : item.tax_payer.state == "edit"
                ? this.$t("is-editing")
                : item.tax_payer.state == "delete"
                ? this.$t("is-deleting")
                : "");
            this.successAlert = false;
          } else {
            this.$router.push({
              name: this.type + "Edit",
              params: { id: item.uid, tabName: item.number },
            });
          }
        } else {
          this.$router.push({
            name: this.type + "Edit",
            params: { id: item.uid, tabName: item.number },
          });
        }
      }
    },
    editCategory(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoiceCasherEdit",
          params: { id: item.uid, tabName: item.number },
        });
      }
    },
    print(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoicePrint",
          params: { id: item.uid, tabName: item.number },
        });
      }
      // this.printId = item.uid
      // this.invoicePrintDialog = true
    },
    fishPrint(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: "invoiceRollprint",
          params: { id: item.uid, tabName: item.number },
        });
      }
    },
    entrepotPrint(item) {
      if (!this.removedInvoices) {
        this.$router.push({
          name: item.entrepot.type + "Print",
          params: { id: item.entrepot.id },
        });
      }
    },
    getItems() {
      var app = this;
      app.filter = false;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "invoice", {
            params: {
              search: app.search,
              accountProp: app.accountProp ? app.accountProp.id : null,
              account: app.account,
              fromDate: app.fromDate,
              toDate: app.toDate,
              fromDueDate: app.fromDueDate,
              toDueDate: app.toDueDate,
              fromTime: app.fromTime,
              toTime: app.toTime,
              fromAmount: app.fromAmount,
              category: app.category,
              toAmount: app.toAmount,
              fromNumber: app.fromNumber,
              toNumber: app.toNumber,
              currency: app.currencyFilter,
              entrepot: app.entrepot,
              branch: app.branch,
              page: app.allRows ? app.excelPage : app.options.page,
              refId: app.refId,
              type: app.type,
              sortBy: app.sortBy,
              customFields: app.customFields,
              status: app.sellStatus,
              options: app.options,
              tag: app.tag,
              typeForm: app.typeForm,
              registerar: app.registerar,
              lockStatus: app.lockStatus,
              removedInvoices: app.removedInvoices,
              taxpayer: app.$route.name === "sellTaxPayer" ? "active" : null,
              payedStatus: app.payedStatus,
            },
          })
          .then((res) => {
            res = res.data;
            if (!app.allRows) {
              app.items = res.data;
              app.totalItems = res.total;
              app.pageCount = res.last_page;
              app.from = res.from;
              app.summary = res.summary;
              app.creatExcelData(res.data);
              app.selected = [];
            } else {
              app.generateExcellForAllData(res.data, res.last_page);
            }
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => (app.loading = false));
      }, 500);
    },
    invoiceSms(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            invoiceSMS: "active",
            id: item.id,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarColor = "green";
          app.snakbarText = this.$t("sent");
          app.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    sendTaxInvoice(type = null) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            sendTaxInvoice: "active",
            type: type,
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          if (!type) {
            app.snakbarColor = "green";
            app.snakbarText = this.$t("sent");
            app.snakbar = true;
          } else {
            app.getItems();
          }
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    editTaxInvoice(item) {
      var app = this;
      app.loading = true;
      var selected = [item.id];
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            editTaxInvoice: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          // if (!type) {
          //   app.snakbarColor = 'green'
          //   app.snakbarText = this.$t('sent')
          //   app.snakbar = true
          // } else {
          app.getItems();
          // }
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    selectedPrint(item) {
      this.selected = [item];
      this.groupPrintDialog = true;
    },
    groupPrintInvoice() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            groupPrint: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.$router.push({
            name: "reportViewer",
            params: { dataProp: res, reportProp: app.printType },
          });
          app.selected = [];
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      app.loading = true;
      if (
        app.deleteItem &&
        app.deleteItem.tax_payer &&
        ((app.deleteItem.tax_payer.state == "new" &&
          app.deleteItem.tax_payer.status == "PENDING") ||
          (app.deleteItem.tax_payer.state == "edit" &&
            app.deleteItem.tax_payer.status == "PENDING") ||
          (app.deleteItem.tax_payer.state == "delete" &&
            app.deleteItem.tax_payer.status == "PENDING"))
      ) {
        // show a dialog
        app.snakbar = true;
        app.snakbarText =
          app.$t("your invoice is pending to") +
          (app.deleteItem.tax_payer.state == "new"
            ? app.$t("is-sending")
            : app.deleteItem.tax_payer.state == "edit"
            ? app.$t("is-editing")
            : app.deleteItem.tax_payer.state == "delete"
            ? app.$t("is-deleting")
            : "");
        app.snakbarColor = "red";
      } else {
        if (app.removeType == "delete") {
          app.$axios
            .delete(app.$apipoint + `v2/invoice/${app.deleteItem.id}`)
            .then((res) => {
              res = res.data;
              app.deletDialog = false;
              app.deleteItem = null;
              app.selected = [];
              app.getItems();
            })
            .catch((err) => {
              app.deletDialog = false;
              app.serverErrorHandeler(err);
            })
            .finally(function () {
              app.deleteItem = null;
              app.selected = [];
              app.loading = false;
            });
        }
        if (this.removeType == "annulment") {
          app.$axios
            .delete(app.$apipoint + `v2/revoke-invoice/${app.deleteItem.id}`)
            .then((res) => {
              res = res.data;
              app.deletDialog = false;
              app.deleteItem = null;
              app.selected = [];
              app.getItems();
            })
            .catch((err) => {
              app.deletDialog = false;
              app.serverErrorHandeler(err);
            })
            .finally(function () {
              app.deleteItem = null;
              app.selected = [];
              app.loading = false;
            });
        }
      }
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];

      if (app.removeType == "delete") {
        app.selected.map(function (value, key) {
          if (app.resolveDeleteBtnVisibility(value)) {
            selected.push(value.id);
          }
        });

        app.$axios
          .delete(app.$apipoint + "v2/group-destroy", {
            params: {
              id: selected,
            },
          })
          .then((res) => {
            res = res.data;
            app.deletDialog = false;
            app.deleteItem = null;
            app.selected = [];
            app.getItems();
          })
          .catch((err) => {
            app.deletDialog = false;
            app.deleteItem = null;
            app.serverErrorHandeler(err);
          })
          .finally(function () {
            app.selected = [];
            app.loading = false;
          });
      }

      if (app.removeType == "annulment") {
        app.selected.map(function (value, key) {
          if (app.resolveAnnulmentBtnVisibility(value)) {
            selected.push(value.id);
          }
        });

        app.$axios
          .get(app.$apipoint + "v2/group-revoke-invoice", {
            params: {
              id: selected,
            },
          })
          .then((res) => {
            res = res.data;
            app.deletDialog = false;
            app.deleteItem = null;
            app.selected = [];
            app.getItems();
          })
          .catch((err) => {
            app.deletDialog = false;
            app.serverErrorHandeler(err);
          })
          .finally(function () {
            app.deleteItem = null;
            app.selected = [];
            app.loading = false;
          });
      }
    },
    getPermissions() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getPermissions",
          },
        })
        .then((res) => {
          res = res.data;
          app.$store.commit("SET_PERMISSIONS", res.permissions);
        });
    },
    fetchCheckAverageFirst() {
      if (this.selectedCheck && this.selectedCheck.length == 0) {
        this.snakbarText =
          this.$t("first add some items from list") +
          "(" +
          this.$t("only invoices with due-date can be calculated") +
          ")";
        this.snakbarColor = "red";
        this.snakbar = true;
      }

      if (this.invoice_without_due_date && this.invoice_without_due_date.length > 0) {
        this.isThereInvoiceWithoutId = true;
      }

      /* if (this.invoice_without_due_date != null) {
          const invoiceID_without_due_date = this.invoice_without_due_date.map(item => item.id)

          if (invoiceID_without_due_date.length > 0) {
            this.snakbarText = `${this.$t("selected item doesn't have due date")} : ${invoiceID_without_due_date.join(', ')}`
            this.snakbarColor = 'red'
            this.snakbar = true
          }
        } */

      this.selectedCheck.forEach((item) => {
        this.checksID.push(item.id);
      });
      if (this.checksID.length > 0) {
        var app = this;
        this.loading = true;
        app.$axios
          .post(app.$endpoint + "duedateInvoice/store", {
            ids: this.checksID,
            base_date: moment(this.today, "jYYYY/jM/jD").format("YYYY-MM-DD"),
          })
          .then((r) => {
            if (r.data) {
              this.checkAverageDate = r.data.due_date;
              if (this.checkAverageDate) {
                this.checkAverageDialog = true;
              }
              this.checksID = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            if (
              err.response &&
              (err.response.status == 422 || err.response.status == 403)
            ) {
              this.snakbarText = this.$t("can't change to lower plan");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    fetchCheckAverageSecond() {
      this.loading = true;
      this.checkAverageItems.forEach((item) => {
        this.checksID.push(item.id);
      });
      if (this.checksID.length > 0) {
        var app = this;
        app.$axios
          .post(app.$endpoint + "duedateInvoice/store", {
            ids: this.checksID,
            base_date: moment(this.selectedDate, "jYYYY/jM/jD").format("YYYY-MM-DD"),
          })
          .then((r) => {
            if (r.data) {
              this.checkAverageDate = r.data.due_date;
              this.checksID = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            if (
              err.response &&
              (err.response.status == 422 || err.response.status == 403)
            ) {
              this.snakbarText = this.$t("can't change to lower plan");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    openCheckDeleteDialog(select, checkId) {
      this.checkDeleteDialog = true;
      if (select == "all") {
        this.deleteAllCheck = true;
      } else {
        this.deleteAllCheck = false;
        this.selectedCheckID = checkId;
      }
    },
    deleteCheck() {
      if (this.deleteAllCheck) {
        this.checkAverageItems = [];
        this.selected = [];
      } else {
        const selectedCheckIndexTable = this.checkAverageItems.findIndex(
          (item) => item.id == this.selectedCheckID
        );
        this.checkAverageItems.splice(selectedCheckIndexTable, 1);
      }
      this.checkDeleteDialog = false;
    },
    resolveChecksTotal() {
      this.checksTotal = this.checkAverageItems.reduce((sum, item) => {
        return sum + Number(item.price ? item.price.price : 0);
      }, 0);
    },
    taxPayerConfirmation() {
      if (this.taxPayerSelectedItems && this.taxPayerSelectedItems.length > 0) {
        this.taxPayerConfirmDialog = true;
      } else {
        this.snakbar = true;
        this.snakbarText = this.$t("time-is-up");
        this.snakbarColor = "red";
      }
    },
    sendToTaxPayer() {
      var app = this;
      app.loading = true;
      app.$axios
        .post(this.$apipoint + "v2/" + "tax-payer/send", {
          items: this.taxPayerSelectedItems.map((item) => item.id),
        })
        .then((r) => {
          this.invoiceErrorItems = r.data
            .filter((item) => item.hasError == true)
            .map((item) => ({
              invoice: item.invoice,
              data: item.data,
            }));

          if (this.invoiceErrorItems && this.invoiceErrorItems.length > 0) {
            this.taxPayerConfirmDialog = false;
            this.invoiceErrorDialog = true;
          } else {
            this.taxPayerConfirmDialog = false;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showErrorDetails(item) {
      this.invoiceErrorDetailsDialog = true;
      this.selectedInvoiceItem = item;
      this.selectedInvoiceErrors = item.data[0].error;
    },
    editInvoice() {
      this.$router.push({
        name: "sellEdit",
        params: {
          id: this.selectedInvoiceItem.invoice.uid,
          tabName: this.selectedInvoiceItem.invoice.uid,
        },
      });
    },
    resolveTaxPayerStatus(item) {
      if (item.state) {
        // new
        if (item.state == "new") {
          if (item.status == "PENDING") {
            return this.$t("pending-new");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-new");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-new");
          }
        }
        // edit
        if (item.state == "edit") {
          if (item.status == "PENDING") {
            return this.$t("pending-edit");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-edit");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-edit");
          }
        }
        // delete
        if (item.state == "delete") {
          if (item.status == "PENDING") {
            return this.$t("pending-delete");
          }
          if (item.status == "SUCCESS") {
            return this.$t("success-delete");
          }
          if (item.status == "FAILED") {
            return this.$t("failed-delete");
          }
        }
      }
    },
    resolveTaxPayerStatusColor(item) {
      if (item.state) {
        // new
        if (item.state == "new" || item.state == "edit" || item.state == "delete") {
          if (item.status == "PENDING") {
            return "primary";
          }
          if (item.status == "SUCCESS") {
            return "success";
          }
          if (item.status == "FAILED") {
            return "error";
          }
        }
      }
    },
    openTaxPayerStatus(item) {
      if (item.state) {
        if (item.state == "new" || item.state == "edit" || item.state == "delete") {
          if (item.status == "FAILED") {
            this.taxPayerStatusError = item;
            this.taxPayerStatusErrorItems = JSON.parse(item.reponse).data[0].error;
            if (this.taxPayerStatusErrorItems) {
              this.taxPayerStatusReviewDialog = true;
            }
            this.successAlert = false;
          }
          if (item.status == "PENDING") {
            this.alertDialog = true;
            this.alertDialogText =
              this.$t("your invoice is pending to") +
              (item.state == "new"
                ? this.$t("is-sending")
                : item.state == "edit"
                ? this.$t("is-editing")
                : item.state == "delete"
                ? this.$t("is-deleting")
                : "");
            this.successAlert = false;
          }
          if (item.status == "SUCCESS") {
            this.alertDialog = true;
            this.alertDialogText = this.$t("your invoice is successfuly submited");
            this.successAlert = true;
          }
        }
      }
    },
    taxPayerConfirmationVMenu(item) {
      this.selected.push(item);
      var app = this;
      setTimeout(function () {
        app.taxPayerConfirmation();
      }, 500);
    },
    resolveSubmitionDeadline(createdDate) {
      const created = moment(createdDate, "jYYYY/jMM/jDD");
      const now = moment();

      // بازه‌ی 1 تا 29 اسفند 1404
      const esfStart = moment("1404/12/01", "jYYYY/jMM/jDD");
      const esfEnd = moment("1404/12/29", "jYYYY/jMM/jDD");
      const esfDeadline = moment("1405/01/31", "jYYYY/jMM/jDD");

      // بازه‌ی 1 تا 15 فروردین 1405
      //change this section for ordibehesht
      const farStart = moment("1405/01/01", "jYYYY/jMM/jDD");
      const farEnd = moment("1405/02/15", "jYYYY/jMM/jDD");
      const farDeadline = moment("1405/02/30", "jYYYY/jMM/jDD");

      // شرط اول
      if (created.isBetween(esfStart, esfEnd, undefined, "[]")) {
        const diffDays = Math.ceil(esfDeadline.diff(now, "hours") / 24);
        return diffDays > 0
          ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
          : diffDays === 0
          ? this.$t("today")
          : this.$t("finish-deadline");
        // return diffDays >= 0
        //   ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
        //   : this.$t("finish-deadline");
      }

      // شرط دوم
      if (created.isBetween(farStart, farEnd, undefined, "[]")) {
        const diffDays = Math.ceil(farDeadline.diff(now, "hours") / 24);
        return diffDays > 0
          ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
          : diffDays === 0
          ? this.$t("today")
          : this.$t("finish-deadline");
        // return diffDays >= 0
        //   ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
        //   : this.$t("finish-deadline");
      }

      // حالت عادی
      const defaultDeadline = created.clone().add(15, "days");
      const diffDays = Math.ceil(defaultDeadline.diff(now, "hours") / 24);

      return diffDays > 0
        ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
        : diffDays === 0
        ? this.$t("today")
        : this.$t("finish-deadline");
      // return diffDays >= 0
      //   ? this.$t("submission-deadline") + " " + diffDays + " " + this.$t("days")
      //   : this.$t("finish-deadline");
    },
    // resolveSubmitionDeadline(createdDate) {
    //   const created = moment(createdDate, "jYYYY/jMM/jDD")
    //   const deadline = created.clone().add(30, "days")
    //   const now = moment()

    //   const diffDays = Math.ceil(deadline.diff(now, "hours") / 24)

    //   if (diffDays > 0) {
    //     return this.$t('submission-deadline') + ' ' + diffDays + ' ' + this.$t('days')
    //   } else {
    //     return this.$t('finish-deadline')
    //   }
    // },
    fetchProducts(items) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getProductFromInvoice",
            ids: items.map((item) => item.id),
          },
        })
        .then((r) => {
          app.loading = false;
          this.products = r.data;
          if (this.products && this.products.length > 0) {
            this.$router.push({
              name: "labelPrintSetting",
              params: { items: this.products },
            });
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
        });
    },
    barcodeSingle(item) {
      this.fetchProducts([item]);
    },
    barcode() {
      this.fetchProducts(this.selected);
    },
  },
};
</script>

<style scoped>
::v-deep .v-slide-group__next,
::v-deep .v-slide-group__prev {
  justify-content: inherit;
  min-width: unset;
}
::v-deep .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  height: 48px;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-data-table.checkAverage .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.checkAverage {
  border: 1px solid silver;
  /*  border-bottom: 0;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0; */
  /* height: 300px;
  overflow-y: auto; */
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.checkAverage .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
/* ::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table {
  height: 100%;
} */
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver !important;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  background-color: #eeeeee;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.checkAverage > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.checkAverage
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-data-table.checkAverage.errors > .v-data-table__wrapper > table > tbody > tr {
  background-color: #fff0f3;
}
::v-deep
  .v-data-table.checkAverage.errors
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover {
  background-color: #fff0f3;
}
</style>
